import { IntegrationEmailThread } from '../../../models/Email'
import React from 'react'
import { useLastContactEmailFromThread } from './hooks'
import { EmailTypeSelector } from '../Common/EmailTypeSelector'
import { useAppDispatch } from '../../../store/hooks'
import { addToast } from '../../../store/toast/toastSlice'

export interface EmailTypeCellProps {
  thread: IntegrationEmailThread
}

export const EmailTypeCell: React.FC<EmailTypeCellProps> = ({ thread }) => {
  const dispatch = useAppDispatch()

  const { lastEmailByContact, lastEmailByContactMetadata } = useLastContactEmailFromThread(thread)

  if (!lastEmailByContact) {
    return null
  }

  const handleTypeChanged = () => {
    dispatch(addToast({ variant: 'success', title: 'Success', messages: ['The email type has been updated.'] }))
  }

  return <EmailTypeSelector email={lastEmailByContact} metadata={lastEmailByContactMetadata} onTypeChanged={handleTypeChanged} />
}
